import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { Switch } from '@mui/material'
import { hasPermission } from 'hooks/useBackendMenu'
import { Ocorrencia, ocorrencia } from 'service/api'
import { toast } from 'sonner'

export default function SwitchAtalhoOcorrencia(
    params: GridCellParams<any, Ocorrencia>,
) {
    const atalho = params.row.atalho == 'S'
    const { mutateAsync, isLoading } = ocorrencia.mutations.useUpdate({
        invalidateQuery: true,
    })

    const handleUpdate = () =>
        mutateAsync(
            {
                ...params.row,
                atalho: atalho ? 'N' : 'S',
            },
            {
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Switch
            checked={atalho}
            disabled={isLoading || !hasPermission(['update', 'Ocorrências'])}
            color="primary"
            size="small"
            onChange={handleUpdate}
            title="Caso esteja marcado, a ocorrência será
            exibida na lista de atalhos rápidos da tela de digitação."
        />
    )
}
